


import React from 'react';
import NavigationBar from '../navigation-bar/NavigationBar';


function Layout(props) {


   return (
            <React.Fragment>
                <div className="navBar">
                <NavigationBar />
                </div>
                {props.children}

            </React.Fragment>
        )

}

export default Layout;
